import { render, staticRenderFns } from "./formGroupInput.vue?vue&type=template&id=4b4e2d76&scoped=true&"
import script from "./formGroupInput.vue?vue&type=script&lang=js&"
export * from "./formGroupInput.vue?vue&type=script&lang=js&"
import style0 from "./formGroupInput.vue?vue&type=style&index=0&id=4b4e2d76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4e2d76",
  null
  
)

export default component.exports